































import Vue from 'vue';
import Component from 'vue-class-component';

import { user, layout, maintenanceReports } from '@/modules/shared/shared/store/namespaces';
import { GET_CUSTOMER_ID } from '@/modules/users/store/user.getters';
import ResumeListComponent from '@/modules/invoicing/components/ResumeListComponent.vue';
import ListView from '@/modules/invoicing/components/ListView.vue';
import { maintenanceReportRepository } from '@/modules/reports/shared/repositories/maintenance-reports.repository';
import { GET_MAINTENANCE_REPORTS } from '@/modules/reports/maintenance-reports/store/maintenance-reports.getters';
import { MAINTENANCE_REPORTS_FETCH_ALL } from '@/modules/reports/maintenance-reports/store/maintenance-reports.actions';
import SectionTitle from '@/modules/shared/shared/components/SectionTitle.vue';

@Component({
    components: { SectionTitle, ListView, ResumeListComponent },
})
export default class MaintenanceReportsView extends Vue {
    loading: boolean = false;
    repositoryFunction: Function = (name, location) =>
        maintenanceReportRepository.getReport(name, location);

    @maintenanceReports.Getter(GET_MAINTENANCE_REPORTS) bills;
    @maintenanceReports.Action(MAINTENANCE_REPORTS_FETCH_ALL)
    MAINTENANCE_REPORTS_FETCH_ALL;
    @user.Getter(GET_CUSTOMER_ID) GET_CUSTOMER_ID;
    @layout.Mutation('changeTitle') changeTitle;

    async mounted() {
        this.changeTitle({
            title: 'MANTENIMIENTO',
            route: ['REPORTES', 'INFORMES'],
        });
        this.loading = true;
        await this.MAINTENANCE_REPORTS_FETCH_ALL();

        this.loading = false;
    }
}
